<template>
  <div id="register" class="c-register c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Velkommen</strong> til!
        </h1>
        <p class="f-text">Fortæl os lidt om dig selv.</p>
      </div>

      <div class="l-tablet-column--6">
        <div class="c-error">
          <p class="c-error__text">
            {{ errorMessage }}
            <router-link
              v-if="suggestLogin"
              :to="{ path: '/login', query: query }"
            >Har du allerede en brugerkonto?</router-link>
          </p>
        </div>

        <form class="c-form general-form">
          <input
            v-model="input.name"
            class="c-form__element"
            type="text"
            name="name"
            placeholder="Navn"
          />

          <input
            v-model="input.email"
            class="c-form__element"
            type="email"
            name="email"
            placeholder="Email"
          />

          <input
            v-model="input.password"
            class="c-form__element"
            type="password"
            name="password"
            placeholder="Password"
          />

          <input
            v-model="input.passwordRepeated"
            class="c-form__element"
            type="password"
            name="password-repeated"
            placeholder="Gentag password"
          />

          <div class="c-form__element c-form__checkbox-wrapper form-element-wrapper">
            <input
              id="permission"
              ref="consent"
              v-model="checkedConsent"
              class="c-form__checkbox"
              type="checkbox"
            />
            <label for="permission">
              <span
                class="c-form__checkbox__label"
              >Føljeton er et univers af email-nyhedsbreve. Derfor er vi nødt til at bede dig om tilladelse til at sende dig mails med og om Føljeton. Sæt kryds i kassen.</span>
            </label>
          </div>

          <label
            class="c-form__submit"
            :class="{ 'c-form__submit--disabled': !checkedConsent }"
            @click.prevent="register()"
          >
            <SpinnerButton
              ref="register"
              class="c-form__submit"
              cta="Opret bruger"
              action="Opretter"
            />

            <input type="submit" value="Login" />
          </label>

          <div class="c-secondary-nav">
            <router-link :to="{ path: '/login', query: query }">Har du allerede en brugerkonto?</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Register",
  components: {
    SpinnerButton
  },
  data() {
    console.log(this.$route);
    return {
      errorMessage: "",
      redirect: this.$route.query.redirect || null,
      query: this.$route.query,
      suggestLogin: false,
      input: {
        name: "",
        password: "",
        passwordRepeated: ""
      },
      checkedConsent: false
    };
  },
  methods: {
    register() {
      this.suggestLogin = false;
      console.log("register");
      const validation = this.validateUser();

      // console.log(validation);
      if (validation.validated) {
        //do login
        //console.log(this.$parent)
        this.$userService
          .register({
            name: this.input.name,
            email: this.input.email,
            password: this.input.password
          })
          .then(data => {
            //if (data)
            console.log(data);
            console.log(this.$userService.user);
            if (this.redirect) {
              console.log(this.$route.query.url)
              const params = { name: this.redirect, query: this.query };
              if (this.$route.query.url) {
                params.url = this.$route.query.url;
              }
              this.$router.push(
                params,
                () => {
                  return;
                }
              );
            } else {
              this.$router.push({ name: "creditcard" }, () => {
                return;
              });
            }
          })
          .catch(error => {
            // HAndle error
            this.$refs.register.reset();
            console.log("catch", error.response);
            if (error.response.status === 409) {
              this.handleError({
                error: "Der findes allerede en konto med den email."
              });
              this.suggestLogin = true;
            } else {
              this.handleError({
                error: "Noget gik galt prøv igen senere."
              });
            }
          });
      } else {
        this.handleError(validation);
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validateUser() {
      if (this.input.name == "") {
        return {
          validated: false,
          error: "Navne-feltet skal udfyldes"
        };
      }
      if (this.input.email == "") {
        return {
          validated: false,
          error: "Email-feltet skal udfyldes"
        };
      }
      if (this.input.password == "" || this.input.passwordRepeated == "") {
        return {
          validated: false,
          error: "Begge password-felter skal udfyldes"
        };
      }
      if (this.input.password != this.input.passwordRepeated) {
        return {
          validated: false,
          error: "Password-felterne passer ikke sammen"
        };
      }
      if (this.input.password.length < 6) {
        return {
          validated: false,
          error: "Passwordet skal være mindst 6 tegn"
        };
      }
      if (!this.validateEmail(this.input.email)) {
        return {
          validated: false,
          error: "Det ser ikke ud til at være en rigtig email-adresse"
        };
      }
      return {
        validated: true
      };
    },
    handleError(error) {
      this.$refs.register.reset();
      this.errorMessage = error.error;

      console.log(error);
    }
  }
};
</script>